<template>
  <div class="c-toggle-list__container">
    <div class="c-toggle-list">
      <div class="c-toggle-list__header">
        <div class="c-toggle-list__header-content">
          <h2 v-if="title" class="c-toggle-list__heading">{{ title }}</h2>
          <p v-if="description" class="c-toggle-list__description">
            {{ description }}
          </p>
        </div>
        <button
          v-if="toggle"
          :aria-expanded="collapse ? 'true' : 'false'"
          aria-controls="mapLayers"
          aria-label="Map layers"
          class="c-toggle-list__button"
          v-on:click="dropdown"
        >
          <svg
            v-if="collapse"
            class="c-toggle-list__icon"
            aria-hidden="true"
            focusable="false"
          >
            <use
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="#arrow-up"
            />
          </svg>
          <svg
            v-if="!collapse"
            class="c-toggle-list__icon"
            aria-hidden="true"
            focusable="false"
          >
            <use
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="#arrow-down"
            />
          </svg>
        </button>
      </div>
    </div>
    <div v-if="layers" id="mapLayers" class="c-toggle-list__panels" :inert="collapse ? null : 'inert'">
      <div
        class="c-toggle-list__panels-container"
        :class="
          collapse
            ? 'c-toggle-list__panels-container--is-visible'
            : 'c-toggle-list__panels-container--is-hidden'
        "
      >
        <div v-for="layer in getSingleLayers" :key="layer.index">
          <MapTogglePanel
            v-if="layer.layerName"
            v-bind:configurable="layer.configurable"
            v-bind:title="layer.layerName"
            v-bind:refId="layer.layerCode"
            v-bind:state="layer.selected"
            v-bind:icon="layer.icon"
            v-on:onToggleChecked="onToggleLayerChecked"
            v-on:onToggleDisabled="onToggleLayerDisabled"
          />
        </div>
        <div
          v-for="layer in getGroups"
          :key="layer.index"
          class="c-toggle-list__group"
        >
          <button
            v-if="layer.groupName"
            class="c-toggle-list__link"
            v-on:click="onToggleGroup(layer.groupCode)"
            :aria-expanded="layer.expanded ? 'true' : 'false'"
            :aria-label="layer.groupName + ' group'"
            :aria-controls="layer.groupName.replaceAll(' ', '-')"
          >
         
            <h4 class="c-toggle-list__link-title">{{ layer.groupName }}</h4>
            <svg
              v-if="layer.expanded"
              class="c-toggle-list__link-icon"
              aria-hidden="true"
              focusable="false"
            >
              <use
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xlink:href="#arrow-up"
              ></use>
            </svg>
            <svg
              v-if="!layer.expanded"
              class="c-toggle-list__link-icon"
              aria-hidden="true"
              focusable="false"
            >
              <use
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xlink:href="#arrow-down"
              ></use>
            </svg>
          </button>
          <div v-if="layer.expanded" :id="layer.groupName.replaceAll(' ', '-')">
            <MapTogglePanel
              v-for="layer in layer.layerConfigurations"
              :key="layer.index"
              v-bind:configurable="layer.configurable"
              v-bind:title="layer.layerName"
              v-bind:refId="layer.layerCode"
              v-bind:state="layer.selected"
              v-bind:icon="layer.icon"
              v-on:onToggleChecked="onToggleLayerChecked"
              v-on:onToggleDisabled="onToggleLayerDisabled"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MapTogglePanel from "./MapTogglePanel";

  export default {
    name: "MapToggleList",
    props: ["description", "layers", "showList", "title", "toggle"],
    components: {
      MapTogglePanel,
    },
    data() {
      return {
        collapse: false,
      };
    },
    computed: {
      getGroups: function () {
        return this.layers.filter((layer) => layer.layerType === "Group");
      },
      getSingleLayers: function () {
        return this.layers.filter((layer) => layer.layerType !== "Group");
      },
    },
    mounted() {
      this.collapse = this.showList;
    },
    methods: {
      dropdown() {
        if (this.toggle) {
          this.collapse = !this.collapse;
        }
      },
      onToggleGroup(group) {
        this.$emit("onToggleGroup", group);
      },
      onToggleLayerChecked(name) {
        this.$emit("onToggleLayerChecked", name);
      },
      onToggleLayerDisabled(name) {
        this.$emit("onToggleLayerDisabled", name);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/layered-map/MapToggleList.vue